module.exports = __webpack_public_path__ + "img/ic_list_info_chart.81557f34.svg";